module.exports = __webpack_public_path__ + "static/hero--large-90bedc82777f02fd23339d91f22ae3d6.jpg";